// removed by extract-text-webpack-plugin
module.exports = {"container":"styles-container--1NgW4","list":"styles-list--3sjWh","detail":"styles-detail--1ItKi","listFilter":"styles-listFilter--1GqPo","listItems":"styles-listItems--dar6q","active":"styles-active--1uDSQ","vipLetter":"styles-vipLetter--27vN0"};


//////////////////
// WEBPACK FOOTER
// /src/components/Segments/styles.scss
// module id = azRA
// module chunks = 1